import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { throwError as observableThrowError, of, Subject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Http, Response } from '@angular/http/';
import 'rxjs/Rx';
import * as jwt_decode from 'jwt-decode';
import * as moment from 'moment';
import { environment } from "./../../../environments/environment";
import * as i0 from "@angular/core";
import * as i1 from "@angular/http";
import * as i2 from "@angular/common/http";
export var TOKEN_NAME = 'access_token';
var LoginService = /** @class */ (function () {
    function LoginService(http, httpClient) {
        this.http = http;
        this.httpClient = httpClient;
        this.tokenSubject = new Subject();
        this.ssoServer = "" + environment.AUTH_SERVER_URL;
        this.loginSystem = environment.AUTH_URL + "/home?action=logout&app=attendance";
    }
    LoginService.prototype.searchEmployee = function (str) {
        var params = new HttpParams();
        params = params.set('name', str);
        return this.http.get(environment.SERVER_URL + '/staff/search-by-name' + str, { params: params }).pipe(map(this.extractData), catchError(this.handleError));
    };
    // old route: /individual_employment_setting/detail/' + id
    LoginService.prototype.getAttendanceSetting = function (id) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('access_token')
        });
        var options = { headers: headers };
        return this.httpClient.get(environment.SERVER_URL + '/individual_employment_setting/detail_by_date?staff_id=' + id + '&date=' + moment().format('YYYY-MM-DD'), options).pipe(map(this.extractData), catchError(this.handleError));
    };
    LoginService.prototype.getToken = function () {
        return localStorage.getItem(TOKEN_NAME);
    };
    LoginService.prototype.setToken = function (token) {
        localStorage.setItem(TOKEN_NAME, token);
    };
    LoginService.prototype.getTokenExpirationDate = function (token) {
        var decoded = jwt_decode(token);
        if (decoded['exp'] === undefined) {
            return null;
        }
        var date = new Date(0);
        date.setUTCSeconds(decoded['exp']);
        return date;
    };
    LoginService.prototype.isTokenExpired = function (token) {
        if (!token) {
            token = this.getToken();
        }
        if (!token) {
            return true;
        }
        var date = this.getTokenExpirationDate(token);
        if (date === undefined) {
            return false;
        }
        return !(date.valueOf() > new Date().valueOf());
    };
    LoginService.prototype.logout = function () {
        localStorage.removeItem('currentUser');
        localStorage.removeItem(TOKEN_NAME);
        localStorage.removeItem('setting');
        localStorage.removeItem('branch');
        localStorage.removeItem('worklistStaffs');
        localStorage.removeItem('attendanceStaffs');
        localStorage.removeItem('alertDetails');
        localStorage.removeItem('userInfo');
        localStorage.removeItem('previousState');
        localStorage.removeItem('alertData');
        localStorage.removeItem('applicationDetails');
        localStorage.removeItem('access_token');
        localStorage.removeItem('alert_id');
        localStorage.removeItem('previousRoute');
        // redirect to login system
        console.log(this.loginSystem);
        window.location.href = this.loginSystem;
    };
    // to be fix
    LoginService.prototype.recoverPassword = function (email) {
        var body = JSON.stringify({ email: email });
        var headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        var options = { headers: headers };
        // This function needs to be created in login system.
        return this.httpClient.post(environment.DB_API_URL + '/recoverPassword', body, options).pipe(map(this.extractData), catchError(this.handleError));
    };
    LoginService.prototype.extractData = function (res) {
        var body = res;
        return body.data || {};
    };
    LoginService.prototype.validateToken = function () {
        var headers = new HttpHeaders({ 'content-type': 'application/json' });
        var token = this.getToken();
        var body = {
            token: token,
            app: 'ams'
        };
        return this.httpClient.post(environment.AUTH_SERVER_URL + '/appValidatetoken', body, { headers: headers })
            .pipe(catchError(this.newErrorHandler));
    };
    LoginService.prototype.decodeToken = function (token) {
        if (!token) {
            token = localStorage.getItem('access_token');
        }
        return jwt_decode(token);
    };
    // use to request token from the iframe login system
    LoginService.prototype.requestToken = function () {
        var iframe = document.getElementById('login-system');
        // skip if no iframe is found
        if (iframe == null)
            return;
        var iWindow = iframe.contentWindow;
        iWindow.postMessage('attendance', environment.AUTH_URL);
        return;
    };
    LoginService.prototype.handleError = function (error) {
        var errMsg;
        if (error instanceof Response) {
            var body = error.json() || '';
            var err = body.error || JSON.stringify(body);
            errMsg = error.status + " - " + (error.statusText || '') + " " + err;
        }
        else {
            errMsg = error.message ? error.message : error.toString();
        }
        return observableThrowError(errMsg);
    };
    LoginService.prototype.newErrorHandler = function (error) {
        var errorMessage = 'Unknown error!';
        if (error.error instanceof ErrorEvent) {
            // Client-side errors
            errorMessage = "Error: " + error.error.message;
        }
        else {
            // Server-side errors
            if (error.status == 403) {
                return of({ data: null, message: '403', success: false });
            }
            else {
                return of({ data: null, message: '401', success: false });
            }
        }
        return of({ data: null, message: errorMessage, success: false });
    };
    LoginService.ngInjectableDef = i0.defineInjectable({ factory: function LoginService_Factory() { return new LoginService(i0.inject(i1.Http), i0.inject(i2.HttpClient)); }, token: LoginService, providedIn: "root" });
    return LoginService;
}());
export { LoginService };
